module.exports = __webpack_public_path__ + "static/media/diuretic-icon.c6fcbb2b.png";